/**
 * Meal Set ID Manager
 * 
 * Manages meal_set_id for a successfully generated meal set.
 * Created on "Meal Set Generation Succeeded", used for all subsequent events.
 */

import { STORAGE_KEYS } from './constants';

/**
 * Generate a UUID v4
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}

// In-memory storage for current meal set
let currentMealSetId = null;

/**
 * Create a new meal_set_id
 * Call this when meal set generation succeeds
 * @returns {string}
 */
export function createMealSetId() {
  currentMealSetId = generateUUID();
  try {
    sessionStorage.setItem(STORAGE_KEYS.MEAL_SET_ID, currentMealSetId);
  } catch (e) {
    console.warn('[Analytics] Error saving meal_set_id:', e);
  }
  return currentMealSetId;
}

/**
 * Set meal_set_id from backend (if backend provides one)
 * @param {string} id 
 */
export function setMealSetId(id) {
  currentMealSetId = id;
  try {
    sessionStorage.setItem(STORAGE_KEYS.MEAL_SET_ID, id);
  } catch (e) {
    console.warn('[Analytics] Error saving meal_set_id:', e);
  }
}

/**
 * Get current meal_set_id
 * @returns {string|null}
 */
export function getMealSetId() {
  if (currentMealSetId) {
    return currentMealSetId;
  }
  
  try {
    const stored = sessionStorage.getItem(STORAGE_KEYS.MEAL_SET_ID);
    if (stored) {
      currentMealSetId = stored;
      return stored;
    }
  } catch (e) {
    console.warn('[Analytics] Error reading meal_set_id:', e);
  }
  
  return null;
}

/**
 * Clear meal_set_id
 * Call this when starting a completely new flow
 */
export function clearMealSetId() {
  currentMealSetId = null;
  try {
    sessionStorage.removeItem(STORAGE_KEYS.MEAL_SET_ID);
  } catch (e) {
    console.warn('[Analytics] Error clearing meal_set_id:', e);
  }
}
